import { render, staticRenderFns } from "./LongTermSetPrice.vue?vue&type=template&id=b920c48e&scoped=true&"
import script from "./LongTermSetPrice.vue?vue&type=script&lang=js&"
export * from "./LongTermSetPrice.vue?vue&type=script&lang=js&"
import style0 from "./LongTermSetPrice.vue?vue&type=style&index=0&id=b920c48e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b920c48e",
  null
  
)

export default component.exports